module.exports = __webpack_public_path__ + "assets/images/1$R.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/1$R.png
// module id = 1273
// module chunks = 1